import { render, staticRenderFns } from "./SoccerScoresMatchStatistics.vue?vue&type=template&id=79af53ba&"
import script from "./SoccerScoresMatchStatistics.vue?vue&type=script&lang=js&"
export * from "./SoccerScoresMatchStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports